/*********************
 *  DEFAULT ROUTES   *
 *********************/

export const ROUTE_HOME = '/';
// export const ROUTE_CARELEVEL_CHECK = '/pflegegrad-check';
// export const ROUTE_CARELEVEL_CHECK_START = '/pflegegrad-check/start';
export const ROUTE_LOGIN = '/anmelden';
export const ROUTE_REGISTER = '/registrieren';
export const ROUTE_FORGOT_PASSWORD = '/passwort-vergessen';
export const ROUTE_RESET_PASSWORD = '/passwort-zuruecksetzen';
export const ROUTE_SERVICE_CARELEVEL_CALCULATOR = '/service/pflegegradrechner';
export const ROUTE_SERVICE_CARELEVEL_CALCULATOR_PREWIZARD = `${ROUTE_SERVICE_CARELEVEL_CALCULATOR}/start`;
export const ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD = `${ROUTE_SERVICE_CARELEVEL_CALCULATOR}/wizard`;
export const ROUTE_SERVICE_CARELEVEL_CALCULATOR_REGISTER = `${ROUTE_SERVICE_CARELEVEL_CALCULATOR}/registrieren`;
export const ROUTE_PROFILE = '/profil';
export const ROUTE_PRIVACY = '/datenschutz';
export const ROUTE_CARE_PROFILE = '/pflegeprofile/';

/*********************
 *    AUTH ROUTES    *
 *********************/

export const ROUTE_DASHBOARD = '/uebersicht';
export const ROUTE_INTRO = '/intro';
export const ROUTE_TASK_SCHEDULER = '/aufgabenplaner';
export const ROUTE_SERVICE_PFLEGELEISTUNGSFINDER = '/service/pflegeleistungsfinder';
export const ROUTE_SERVICE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS = '/service/belastungsbewertung';
export const ROUTE_SERVICE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS_WIZARD = `${ROUTE_SERVICE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS}/wizard`;
export const ROUTE_ANALYSE_CARE_LEVEL = '/analysen/pflegegrad';
export const ROUTE_ANALYSE_CARE_SERVICE = '/analysen/pflegeleistungen';
export const ROUTE_ANALYSE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS = '/analysen/belastung';
export const ROUTE_APPLICATIONS = '/antragsbereich';
export const ROUTE_CARE_PROFILES = '/pflegeprofile';
export const ROUTE_CONTACT = '/kontakt';

/*********************
 *  EXTERNAL ROUTES  *
 *********************/

export const EXTERNAL_ROUTE_IMPRINT = 'https://www.pflege.de/impressum/';
export const EXTERNAL_ROUTE_HOME = 'https://www.pflege.de/';
